import React, { useState } from 'react';
import './Donation.css';
import { useLanguage } from '../context/LanguageContext';

const Donation = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    amount: '',
    purpose: 'general',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      amount: '',
      purpose: 'general',
      message: ''
    });
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch('https://mhaskobaadmin.tipic.in/api/donate/initiate', {  // adjust URL if needed (or full http://localhost:8000/api/...)
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.message || 'ऑर्डर तयार करताना त्रुटी');
      }

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        throw new Error('Razorpay लोड झाला नाही');
      }

      const options = {
        key: data.key,
        amount: data.amount,
        currency: 'INR',
        name: 'श्री श्रीनाथ म्हस्कोबा महाराज मंदिर',
        description: `दान - ${data.purpose}`,
        order_id: data.order_id,
        prefill: {
          name: data.name,
          email: data.email,
          contact: data.phone,
        },
        notes: {
          purpose: data.purpose,
        },
        theme: { color: '#F37254' },
        handler: async function (response) {

          resetForm();
          // Payment successful → verify
          const verifyRes = await fetch('https://mhaskobaadmin.tipic.in/api/donate/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              amount: data.amount,
              name: data.name,
              email: data.email,
              phone: data.phone,
              purpose: data.purpose,              // ← हे महत्त्वाचे आहे
              message: formData.message,

            }),
          });

          const verifyData = await verifyRes.json();

          if (verifyData.success) {
            setMessage(verifyData.message);
            setFormData({ name: '', email: '', phone: '', amount: '', purpose: 'general', message: '' });
          } else {
            setMessage('पेमेंट यशस्वी झाले पण सत्यापनात त्रुटी आली.');
          }
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (err) {
      setMessage(err.message || 'काहीतरी चूक झाली. पुन्हा प्रयत्न करा.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="donation-page">
      <section className="donation-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('pageContent.donateNow')}</span>
          <h1>{t('donation.pageTitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <div className="container">
        <section className="donation-intro">
          <p>
            {t('donation.intro')}
          </p>
        </section>

        <div className="donation-content">
          <div className="donation-form-section">
            <h2>{t('donation.formTitle')}</h2>
            {message && (
              <div className={`alert ${message.includes('यशस्वी') || message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
                {message}
              </div>
            )}
            <form className="donation-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>{t('donation.fullName')} *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.fullNamePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label>{t('donation.emailAddress')} *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.emailPlaceholder')}
                />
              </div>

              <div className="form-group">
                <label>{t('donation.phoneNumber')} *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder={t('contact.phonePlaceholder')}
                />
              </div>

              <div className="form-group">
                <label>{t('donation.donationAmount')} *</label>
                <input
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                  placeholder={t('donation.donationAmount')}
                  min="1"
                />
              </div>

              <div className="form-group">
                <label>{t('donation.donationPurpose')} *</label>
                <select
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleChange}
                  required
                >
                  <option value="general">{t('donation.donationPurposes.general')}</option>
                  <option value="annadan">{t('donation.donationPurposes.annadan')}</option>
                  <option value="development">{t('donation.donationPurposes.development')}</option>
                  <option value="gaushala">{t('donation.donationPurposes.gaushala')}</option>
                  <option value="festival">{t('donation.donationPurposes.festival')}</option>
                  <option value="maintenance">{t('donation.donationPurposes.maintenance')}</option>
                </select>
              </div>

              <div className="form-group">
                <label>{t('donation.message')}</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder={t('contact.messagePlaceholder')}
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Processing...' : t('donation.proceedToPayment')}
              </button>
            </form>
          </div>

          <div className="donation-info-section">
            <div className="info-card">
              <h3>{t('donation.quickDonationOptions')}</h3>
              <div className="quick-amounts">
                <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '500' })}>₹500</button>
                <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '1000' })}>₹1,000</button>
                <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '2500' })}>₹2,500</button>
                <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '5000' })}>₹5,000</button>
                <button className="amount-btn" onClick={() => setFormData({ ...formData, amount: '10000' })}>₹10,000</button>
              </div>
            </div>

            <div className="info-card">
              <h3>{t('donation.upiPayment')}</h3>
              <div className="qr-placeholder">
                <span className="qr-icon">📲</span>
                <p>{t('donation.scanQRCode')}</p>
              </div>
              <p className="upi-id">{t('donation.upiId')}</p>
            </div>

            <div className="info-card">
              <h3>{t('donation.bankDetails')}</h3>
              <div className="bank-details">
                <p><strong>{t('donation.accountName')}</strong></p>
                <p><strong>{t('donation.accountNumber')}</strong></p>
                <p><strong>{t('donation.ifscCode')}</strong></p>
                <p><strong>{t('donation.bank')}</strong></p>
                <p><strong>{t('donation.branch')}</strong></p>
              </div>
            </div>

            <div className="info-card tax-benefit">
              <h3>{t('donation.taxBenefits')}</h3>
              <p>
                {t('donation.taxText')}
              </p>
            </div>
          </div>
        </div>

        <section className="donation-impact">
          <h2 className="section-title">{t('donation.howYourDonationHelps')}</h2>
          <div className="divider"></div>

          <div className="impact-grid">
            <div className="impact-card">
              <div className="impact-icon">🍽️</div>
              <h3>{t('donation.annadan.title')}</h3>
              <p>{t('donation.annadan.description')}</p>
            </div>
            <div className="impact-card">
              <div className="impact-icon">🏛️</div>
              <h3>{t('donation.templeDevelopment.title')}</h3>
              <p>{t('donation.templeDevelopment.description')}</p>
            </div>
            <div className="impact-card">
              <div className="impact-icon">🐄</div>
              <h3>{t('donation.gauSeva.title')}</h3>
              <p>{t('donation.gauSeva.description')}</p>
            </div>
            <div className="impact-card">
              <div className="impact-icon">🎉</div>
              <h3>{t('donation.festivals.title')}</h3>
              <p>{t('donation.festivals.description')}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Donation;
